import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth/auth.service.service';
import { SharedService } from '../services/Shared/shared.service';
import { Router, ActivatedRoute } from '@angular/router';
import { cloudsearch } from 'googleapis/build/src/apis/cloudsearch';
import { environment } from '../../environments/environment';

import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public copyRightsDate: Date = new Date();
  public loginData = {
    EmailAddress: null,
    Password: null,
    RememberMe: null
  };
  public loginResult;
  public ForgotPasswordEmail;
  public btnSignIn = false;
  public btnSignInText = "SIGN IN";
  public CompanyLogo = "";
  public CompanyLogoBg = "";
  public showForgotPassword = false;
  public showLogin = false;
  public encryptSecretKey = "1234567890";
  public token = "";
  public errorPassword = ""
  public changePasswordForm: any = {
    OldPassword: '',
    NewPassword: '',
    RepeatPassword: ''
  }
  public accountExpired = false;
  public activateToken = '';

  constructor(
    private loginService: AuthService,
    private sharedService: SharedService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.activatedRoute.queryParams.subscribe(change => {
      let { token, activate } = change;
      if (token) {
        this.token = token;
        this.showLogin = false;
        this.showForgotPassword = false;
      } else if (activate) {
        this.reActivateAccount(activate);
      }
      else {

        this.showLogin = true;
        this.showForgotPassword = false;
        this.token = ''
      }
    })
  }

  ngOnInit(): void {
    if (sessionStorage.getItem("rememberMe"))
      this.loginData = this.decryptData(sessionStorage.getItem("rememberMe"));
    const qsParam: string = this.activatedRoute.snapshot.queryParamMap.get('c');
    if (qsParam) {

      this.CompanyLogo = '../assets/img/Company/' + qsParam + '/logo_login.png';
      this.CompanyLogoBg = "../assets/img/Company/" + qsParam + "/login_bg.png";

      fetch(this.CompanyLogo, { method: 'HEAD' })
        .then(res => {
          if (res.ok) {
            //console.log('Image exists.');
          } else {
            this.CompanyLogo = "../assets/img/ba-logo.png";
          }
        }).catch(err => console.log('Error:', err));

      fetch(this.CompanyLogoBg, { method: 'HEAD' })
        .then(res => {
          if (res.ok) {
            //console.log('Image exists.');
          } else {
            this.CompanyLogoBg = "../assets/img/login_bg.png";
          }
        }).catch(err => console.log('Error:', err));

    }
    else {
      this.CompanyLogo = "../assets/img/ba-logo.png";
      this.CompanyLogoBg = "../assets/img/login_bg.png";
    }
  }

  reActivateAccount(activate) {
    this.loginService.activateAccount({ token: activate }).subscribe((result: any) => { 
      $(".activate-success").html('Account Activated Successfully! <a href="./">Click here</a> to login. <br><br><br>').show();
    });
  }

  sendReactiveMail() {
    console.log(`${location.origin}/?activate=${this.activateToken}`);
    var request =
      {
        email: this.loginData.EmailAddress,
        emailSubject: "AOC Portal : Forgot Password",
        emailBody: `Click <a href="${location.origin}/?activate=${this.activateToken}">here</a> to Change the password
            <br>
            <a href="${location.origin}/?activate=${this.activateToken}">${location.origin}/?activate=${this.activateToken}</a>`
      }
    this.loginService.ForgotPassword(request).subscribe(result => {
      if (result) {
        this.accountExpired = false;
        $(".errorfp-success").text('Email sent successfully').show().delay(5000).fadeOut();
        return false;
      }
    }, error => {
      //console.log('Failed to send email.' + error.reason + error.status);     
      $(".errorfp-msg").text(error.reason).show().delay(5000).fadeOut();
      return false;
    })
  }

  changePassword() {
    if (this.changePasswordForm.NewPassword === this.changePasswordForm.RepeatPassword) {
      this.loginService.changePassword({ ...this.changePasswordForm, token: this.token }).subscribe((result: any) => {
        this.errorPassword = "";
        this.router.navigate(['./'], {
          relativeTo: this.activatedRoute,
          queryParams: { token: '' },
          queryParamsHandling: 'merge'
        });
      });
    } else {
      this.errorPassword = "New Password and Repeat password doesnt match";
    }

  }

  login() {
    this.btnSignIn = true;
    this.accountExpired = false;
    this.btnSignInText = "Wait..."


    if (this.loginData.RememberMe) {
      sessionStorage.setItem("rememberMe", this.encryptData(this.loginData));
    }

    this.loginService.login(this.loginData).subscribe((result: any) => {

      let { LastPasswordUpdatedOn, Token, LastLoginDate } = result;

      if (LastLoginDate) {
        const date1: any = new Date(LastLoginDate);
        const date2: any = new Date(new Date());
        const diffTime = Math.abs(date2 - date1);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays >= 90) {
          this.activateToken = Token;
          this.accountExpired = true;
          return;
        }
      }
      if (LastPasswordUpdatedOn) {
        const date1: any = new Date(LastPasswordUpdatedOn);
        const date2: any = new Date(new Date());
        const diffTime = Math.abs(date2 - date1);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays >= 60) {
          this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: {
              token: Token
            },
            queryParamsHandling: 'merge'
          });

          return;
        }
      }
      if (result) {
        this.loginResult = result;

        //Create Local and session variable for logged in user
        this.sharedService.setUserDetail(result);

        try {
          var userEmailDomain = this.loginData.EmailAddress.split("@", 2);
          sessionStorage.setItem('UserEmailDomain', userEmailDomain[1]);
        }
        catch (ex) { }


        if (this.sharedService.getUserDetail('RoleId') == 4) {
          if (this.sharedService.getUserDetail('CompanyIndustry') == "HealthSight") {
            this.router.navigate(['../site/epi']);
          }
          else {
            this.router.navigate(['../site/dashboard']);
          }
        }
        else {
          this.router.navigate(['../admin/user/user-listing']);
        }

      }
    }, error => {
      this.btnSignIn = false;
      this.btnSignInText = "SIGN IN"
      //console.log('Error: Login' + error.reason + error.status);
      if (error.status == 403) {
        $(".error-msg").text(error.reason).show().delay(5000).fadeOut();
      } else {
        $(".error-msg").text('Login failed').show().delay(5000).fadeOut();
      }
    })
  }

  forgotpassword() {
    this.loginService.GetUser(this.ForgotPasswordEmail).subscribe((result: any) => {
      if (result) {
        this.loginResult = result;
        var request =
          {
            email: this.ForgotPasswordEmail,
            emailSubject: "AOC Portal : Forgot Password",
            emailBody: `Click <a href="${location.origin}/?token=${result.token}">here</a> to Change the password
            <br>
            <a href="${location.origin}/?token=${result.token}">${location.origin}/?token=${result.token}</a>`
          }
        this.ForgotPasswordEmail = "";
        this.loginService.ForgotPassword(request).subscribe(result => {
          if (result) {
            $(".errorfp-success").text('Email sent successfully').show().delay(5000).fadeOut();
            return false;
          }
        }, error => {
          //console.log('Failed to send email.' + error.reason + error.status);     
          $(".errorfp-msg").text(error.reason).show().delay(5000).fadeOut();
          return false;
        })
      }
    }, error => {
      this.ForgotPasswordEmail = ""
      //console.log('Failed to send email.' + error.reason + error.status);    
      if (error.status == 404) {
        $(".errorfp-msg").text('User Not Found...!').show().delay(5000).fadeOut();
        return false;
      } else {
        $(".errorfp-msg").text(error.reason).show().delay(5000).fadeOut();
        return false;
      }

    })



  }

  encryptData(data) {

    try {
      return CryptoJS.AES.encrypt(JSON.stringify(data), this.encryptSecretKey).toString();
    } catch (e) {
      console.log(e);
    }
  }

  decryptData(data) {

    try {
      const bytes = CryptoJS.AES.decrypt(data, this.encryptSecretKey);
      if (bytes.toString()) {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      return data;
    } catch (e) {
      console.log(e);
    }
  }

  FP() {
    this.ForgotPasswordEmail = ""
  }

  openForgotPassword() {
    this.showForgotPassword = true;
    this.showLogin = false;
    this.token = ''
  }
  imageExists(url, callback) {
    var img = new Image();
    img.onload = function () { callback(true); };
    img.onerror = function () { callback(false); };
    img.src = url;
  }


}
